import React from 'react';
import PropTypes from 'prop-types';

const CardWrapper = ({ children }) => {
  return (
    <div className="d-flex flex-column-fluid">
      <div className="container">
        <div className="d-flex flex-row">
          <div className="flex-row-fluid">
            <div className="card card-custom card-stretch">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CardWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CardWrapper;